import { LinkButton } from '@cian/ui-kit';
import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { selectDailyrentBookingGeneral } from 'shared/selectors/dailyrentBooking/dailyrentBooking';
import { selectOfferId, selectOfferType } from 'shared/selectors/offerData/offer';

import { trackViewBookingRequestButtonClick } from './tracking';

const BASE_LK_URL = 'https://my.cian.ru';

const createTripDetailsUrl = (tripId: number | undefined): string => {
  if (!tripId) {
    return BASE_LK_URL;
  }

  return `${BASE_LK_URL}/trips/${tripId}`;
};

export const DailyrentViewBookingRequestButtonContainer = () => {
  const offerId = useSelector(selectOfferId);
  const offerType = useSelector(selectOfferType);
  const { tripId } = useSelector(selectDailyrentBookingGeneral);

  const url = createTripDetailsUrl(tripId);

  const handleClick = useCallback(() => {
    trackViewBookingRequestButtonClick(offerId, offerType, tripId);
  }, [offerId, offerType, tripId]);

  return (
    <LinkButton href={url} onClick={handleClick} fullWidth target="_blank" rel="noopener noreferrer">
      Посмотреть запрос
    </LinkButton>
  );
};
